import { Autocomplete, Box, Button, Divider, Drawer, FormControl, FormControlLabel, IconButton, InputLabel, MenuItem, Paper, Select, styled, Switch, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../global/config/store';
import dayjs, { Dayjs } from 'dayjs';
import { ArrowDropDownIcon, DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { setSelectedMonth } from '../../global/config/Reducer/MonthSlice';
import Domains from '../../global/constants/domain';
import { ApiDownloadExcel, ApiGetAreaManager, ApigetCategoryCmparisionExcel, ApigetCategoryCmparisionReport, ApigetSiteComparisionReport, ApigetSiteWeeklyComparisionReport, ApiGetVenueList, ApiRegionVenues } from '../../apiService/Core/Apicall';
import { RegionList, setRegion } from '../../global/config/Reducer/RegionSlice';
import { toast } from 'react-toastify';
import storage from '../../utils/storage';
import { CloseOutlined, DeleteOutline, EditOutlined, TrendingDownOutlined, TrendingUpOutlined } from '@mui/icons-material';


const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1C2B90';
    if (domain.includes(Domains.MM)) return '#ADB792';

    return '#ADB792';
};

const primary_color = getIconColorByDomain()

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: primary_color,
        color: theme.palette.common.white,
        padding: "10px 20px"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        padding: " 10px 20px",
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: `${primary_color}1A`,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

function SiteComparisionReport() {

    const selectedMonth = useSelector((state: RootState) => state.month.selectedMonth)
    const dispatch = useDispatch()
    const [startMonth, setStartMonth] = React.useState<any>(dayjs(selectedMonth).startOf('year'));
    const [endMonth, setEndMonth] = React.useState<any>(dayjs(selectedMonth).startOf('month'));
    const [monthList, setMonthList] = useState<any>([]);
    const [categoryReport, setCategoryReport] = useState<any>([]);
    const clientEntity = useSelector((state: RootState) => state.clientEntity.selectedEntity);
    const [isGroupScore, setisGroupScore] = useState<boolean>(false);
    const { clientEntityIds } = useSelector((state: RootState) => state.wholegroup)
    const [venuelist, setvenuelist] = useState<any[]>([])
    const [venues, setvenues] = useState<any>('')
    const Regions = useSelector(RegionList)
    const [selectedRegion, setselectedRegion] = useState<number | "">(Regions[0]?.regionId ?? '')
    const [area, setSelectedArea] = useState<number | string | null>(null)
    const [Areamanagerlist, setareamanagerlist] = useState<any[]>([])
    const [period1Start, setPeriod1Start] = useState<any>(null);
    const [period1End, setPeriod1End] = useState<any>(null);
    const [period2Start, setPeriod2Start] = useState<any>(null);
    const [period2End, setPeriod2End] = useState<any>(null);
    const [isCustomDays, setisCustomDays] = useState<boolean>(false);


    const [periods, setPeriods] = useState<any>({
        period1StartDate: null,
        period1EndDate: null,
        period2StartDate: null,
        period2EndDate: null,
    });

    const [periodCount, setPeriodCount] = useState(2);
    const [meta, setmeta] = useState([])
    const [openFilterSidebar, setOpenFilterSidebar] = useState(false);
    const [updateUiTable, setUpdateUiTable] = useState(false)

    const handleDateChange = (
        index: number,
        type: "StartDate" | "EndDate",
        value: Dayjs | null
    ) => {
        const key = `period${index}${type}`;
        setPeriods((prev: any) => ({
            ...prev,
            [key]: value,
        }));
    };

    const addNewPeriod = () => {
        if (periodCount >= 4) {
            toast.error("Maximum 4 periods are allowed");
            return;
        }
        const nextIndex = periodCount + 1;

        setPeriods((prev: any) => ({
            ...prev,
            [`period${nextIndex}StartDate`]: null,
            [`period${nextIndex}EndDate`]: null,
        }));

        setPeriodCount(nextIndex);
    };

    const removePeriod = (removeIndex: number) => {
        // prevent deleting last remaining pair
        if (periodCount === 1) return;

        const updated: any = {};
        let newIndex = 1;

        // rebuild object in sequence 1,2,3...
        for (let i = 1; i <= periodCount; i++) {
            if (i === removeIndex) continue;

            updated[`period${newIndex}StartDate`] = periods[`period${i}StartDate`];
            updated[`period${newIndex}EndDate`] = periods[`period${i}EndDate`];
            newIndex++;
        }

        setPeriods(updated);
        setPeriodCount(periodCount - 1);
    };

    useEffect(() => {
        setEndMonth(dayjs(selectedMonth))
    }, [selectedMonth])

    useEffect(() => {
        const getMonthRange = (start: any, end: any) => {
            const startDate = new Date(start + '-01');
            const endDate = new Date(end + '-01');
            const result = [];

            while (startDate <= endDate) {
                const month = startDate.toLocaleString('en-US', { month: 'short' });
                const year = startDate.getFullYear();
                result.push(`${month}-${year}`);
                startDate.setMonth(startDate.getMonth() + 1);
            }

            return result;
        };

        setMonthList(getMonthRange(`${startMonth.year()}-${startMonth.month() + 1}`, `${endMonth.year()}-${endMonth.month() + 1}`))
    }, [startMonth, endMonth, clientEntity]);

    // const getcategoryreport = async () => {
    //     setCategoryReport([])
    //     if (endMonth && startMonth && clientEntity) {
    //         try {
    //             const data = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}${venues?.length > 0 ? `&venueId=${venues}` : ''}&s_month=${startMonth?.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth?.month() + 1}&e_year=${endMonth.year()}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`
    //             const data2 = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')}${venues?.length > 0 ? `&venueId=${venues}` : ''}&iStartDate=${period1Start?.format('YYYY-MM-DD')}
    //                 &iEndDate=${period1End?.format('YYYY-MM-DD')}
    //                 &lStartDate=${period2Start?.format('YYYY-MM-DD')}
    //                 &lEndDate=${period2End?.format('YYYY-MM-DD')}${(storage.getItem('areaId') || area) ? `&areaId=${area ?? storage.getItem('areaId')}` : ''}`
    //             const res = isCustomDays ? (period1Start && period1End && period2End && period2End && period1Start.isBefore(period1End) &&
    //                 period2Start.isBefore(period2End) && await ApigetSiteWeeklyComparisionReport(data2)) : await ApigetSiteComparisionReport(data)
    //             if (res?.data) {
    //                 setCategoryReport(res?.data);
    //             }
    //         } catch (error) {
    //             console.log("Error", error)
    //         }
    //     }
    // }
    const getcategoryreport = async () => {
        setCategoryReport([]);

        if (!clientEntity) return;

        try {
            const baseQuery = `?clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem("clientEntityId")
                }${venues?.length > 0 ? `&venueId=${venues}` : ""}${storage.getItem("areaId") || area
                    ? `&areaId=${area ?? storage.getItem("areaId")}`
                    : ""
                }`;

            // Normal month compare query
            const data = `${baseQuery}&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1
                }&e_year=${endMonth.year()}`;

            // Dynamic custom periods query
            let data2 = baseQuery;
            if (isCustomDays) {
                for (let i = 1; i <= periodCount; i++) {
                    const startKey = `period${i}StartDate`;
                    const endKey = `period${i}EndDate`;

                    const startDate = periods[startKey];
                    const endDate = periods[endKey];

                    // Validation
                    if (!startDate || !endDate) {
                        toast.error(`Please select both start and end date for Period ${i}`);
                        return;
                    }

                    if (!startDate.isBefore(endDate)) {
                        toast.error(`Period ${i} start date must be before end date`);
                        return;
                    }

                    data2 += `&period${i}StartDate=${startDate.format("YYYY-MM-DD")}`;
                    data2 += `&period${i}EndDate=${endDate.format("YYYY-MM-DD")}`;
                }
            }

            const res = isCustomDays
                ? await ApigetSiteWeeklyComparisionReport(data2)
                : startMonth && endMonth && await ApigetSiteComparisionReport(data);

            if (res?.data) {
                setCategoryReport(res.data);
                setmeta(res?.meta ?? [])
                setUpdateUiTable(isCustomDays)
            }
            setOpenFilterSidebar(false)
        } catch (error) {
            console.log("Error", error);
            toast.error("Something went wrong while fetching category report");
        }
    };
    // useEffect(() => {
    //     !isCustomDays && getcategoryreport()

    // }, [endMonth, startMonth, area, clientEntity, isGroupScore, venues, isCustomDays])


    useEffect(() => {
        const RegionList = async () => {
            if (storage.getItem("clientEntityId") && storage.getItem('ClientGroupName') === "ALDI") {
                const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`

                const response3 = await ApiRegionVenues(data)
                dispatch(setRegion(response3.data))
            }
        }
        RegionList()
    }, [clientEntity])

    useEffect(() => {
        if (Regions.length > 0 && !selectedRegion) {
            setselectedRegion(Regions[0].regionId);
            setvenuelist(Regions[0].venues)
            // setvenues(Regions[0].venues[0].venueId)
        }
    }, [Regions, clientEntity]);

    useEffect(() => {
        const Venuelist = async () => {
            if (!window.location.hostname.includes('aldi')) {
                try {
                    const clientEntityId: any = isGroupScore ? clientEntityIds : storage.getItem('clientEntityId')
                    const response = await ApiGetVenueList(clientEntityId);
                    console.log(response)
                    setvenuelist(response.data);
                    if (response.data.length > 0) {
                        // setvenues(response.data[0].venueId)
                    }
                } catch (error: any) {
                    // toast.error(error)
                }
            }
            else {
                const finalregion = Regions && Regions.find((region: any) => region.regionId === selectedRegion)?.venues;
                setvenuelist(finalregion)
                if (finalregion && finalregion.length > 0) {
                    // setvenues(finalregion[0].venueId)
                }
            }
        };
        Venuelist();
        clientEntity && fetchAreaManagers()

    }, [selectedRegion, clientEntity, isGroupScore])

    useEffect(()=>{
       clientEntity && getcategoryreport()
    },[clientEntity])


    const handledownloadExcel = async () => {
        try {
            let query = `?reportType=${isCustomDays ? "venueComparisonReportWeekly" : "venueComparisonReport"
                }&clientEntityId=${isGroupScore ? clientEntityIds : storage.getItem("clientEntityId")
                }${venues?.length > 0 ? `&venueId=${venues}` : ""}${storage.getItem("areaId") || area
                    ? `&areaId=${area ?? storage.getItem("areaId")}`
                    : ""
                }`;

            if (isCustomDays) {
                for (let i = 1; i <= periodCount; i++) {
                    const startKey = `period${i}StartDate`;
                    const endKey = `period${i}EndDate`;

                    const startDate = periods[startKey];
                    const endDate = periods[endKey];

                    // Validation
                    if (!startDate || !endDate) {
                        toast.error(`Please select both start and end date for Period ${i}`);
                        return;
                    }

                    if (!startDate.isBefore(endDate)) {
                        toast.error(`Period ${i} start date must be before end date`);
                        return;
                    }

                    query += `&period${i}StartDate=${startDate.format("YYYY-MM-DD")}`;
                    query += `&period${i}EndDate=${endDate.format("YYYY-MM-DD")}`;
                }
            } else {
                query += `&s_month=${startMonth.month() + 1}&s_year=${startMonth.year()}&e_month=${endMonth.month() + 1
                    }&e_year=${endMonth.year()}`;
            }

            const response = await ApiDownloadExcel(query);

            const blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            if (blob.size === 0) {
                throw new Error("Empty Excel file.");
            }

            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Site Comparision Report.xlsx`);

            document.body.appendChild(link);
            link.click();

            link.remove();
            URL.revokeObjectURL(url);
        } catch (error: any) {
            const message = error?.response?.message || error?.message;
            toast.error(message);
        }
    };


    const fetchAreaManagers = async () => {
        try {
            const data = `?offset=0&limit=1000&clientEntityId=${isGroupScore ? clientEntityIds : clientEntity}`
            const response = await ApiGetAreaManager(data)
            setareamanagerlist(response.data)
        } catch (error) {
            console.error('Error fetching area managers:', error)
        }
    }
    
    return (
        <Box className='h-100 w-100'>

            <Box className='d-flex align-items-center'>
                <Box
                    borderRadius="50px"
                    width="fit-content"
                    className="d-flex mx-auto mb-3 px-3 py-1 border-main align-items-center"
                    sx={{
                        gap: 1.5,
                        flexWrap: "wrap",
                    }}
                >
                    <Box className='d-flex' gap={1} onClick={() => { setOpenFilterSidebar(true) }}>
                        <Typography fontWeight={600} fontSize="14px"> Filters </Typography>
                        <Typography fontSize="14px" className='m-0 px-2  bg-main text-white' borderRadius={'10px'}> {[
                            selectedRegion,
                            area,
                            venues?.length > 0,
                            isGroupScore,
                            (periods?.period1StartDate && periods?.period1EndDate) || (startMonth && endMonth),
                        ].filter(Boolean).length}
                        </Typography>
                    </Box>

                    <Divider orientation="vertical" flexItem sx={{ borderColor: "black" }} />

                    <Tooltip title="Edit Filters">
                        <IconButton
                            size="small"
                            onClick={() => setOpenFilterSidebar(true)}
                            sx={{ p: 0.5 }}
                        >
                            <EditOutlined fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Box className='d-flex justify-content-end'>
                    <Button variant="contained" className='button-primary' onClick={() => { handledownloadExcel() }} >
                        DOWNLOAD AS XLSX
                    </Button>
                </Box>
            </Box>
            {/* <Box className='d-flex justify-content-end align-items-center flex-wrap' gap={2}>
                {storage.getItem('ClientGroupName') == 'MM' && storage.getItem('userRole') === 'clientadmin' && (
                    <Box>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={isGroupScore}
                                    onChange={(e) => { setSelectedArea(null); setisGroupScore(e.target.checked) }}
                                />
                            }
                            label={"Whole Group"}
                        />
                    </Box>)}
                {storage.getItem('ClientGroupName') == 'MM' && (<Box>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isCustomDays}
                                onChange={(e) => { setSelectedArea(null); setisCustomDays(e.target.checked) }}
                            />
                        }
                        label={"Compare By Custom Dates"}
                    />
                </Box>
                )}
                <Box display={{ xs: "none", md: 'flex' }} className='pe-3 justify-content-between align-items-center' gap={{ xs: 5, lg: 2 }}>
                    {window.location.hostname.includes('aldi') && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '300px' }}>
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ''}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || '');;
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Region"
                                        variant="outlined"
                                        sx={{ input: { color: 'black' } }} // Ensures text is visible
                                    />
                                )}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        </FormControl>
                    )}
                    {storage.getItem('userRole') === 'clientadmin' && storage.getItem('ClientGroupName') !== "ALDI" && (
                        <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                            <Autocomplete
                                className='text-dark'
                                options={Areamanagerlist || []}
                                disabled={isGroupScore}
                                getOptionLabel={(option) => option?.areaName || ''}
                                value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                onChange={(event, newValue) => {
                                    setSelectedArea(newValue?.areaId || '');
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Area" sx={{ color: 'black !important' }} variant="outlined" />
                                )}

                                isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                            />
                        </FormControl>
                    )}
                    <FormControl sx={{ width: 'fit-content', minWidth: '200px' }}>
                        <Autocomplete
                            multiple
                            className="text-dark"
                            options={venuelist || []}
                            getOptionLabel={(option) => option.venueName || ""}
                            value={
                                venuelist?.filter((item) => venues?.includes(item.venueId)) || []
                            }
                            onChange={(event, newValue) => {
                                setvenues(newValue.map((v) => v.venueId)); // store only IDs
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Sites"
                                    sx={{ color: "black !important" }}
                                    variant="outlined"
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                        />
                    </FormControl>
                </Box>

                {!isCustomDays ? (<Box justifyContent={{ xs: 'start', md: 'end' }} className='col-md-auto col-12  d-flex align-itmes-center'>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <Box display="flex" gap={2}>
                            <DatePicker value={startMonth} className='col'
                                label="Start Month: "
                                views={['month', 'year']}
                                format="MMM-YY"
                                maxDate={endMonth}
                                onChange={(e) => { setStartMonth(e); }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                            <DatePicker value={endMonth} className='col'
                                label="End Month:"
                                views={['month', 'year']}
                                format="MMM-YY"
                                minDate={startMonth}
                                onChange={(e: any) => {
                                    const isoString = e?.startOf('month').toISOString();
                                    dispatch(setSelectedMonth(isoString));
                                }}
                                slots={{
                                    openPickerIcon: ArrowDropDownIcon,
                                }}
                            />
                        </Box>
                    </LocalizationProvider>

                </Box>
                )
                    : (
                        <Box className='col-12  d-flex align-items-start'>
                            <Box className="w-100 d-flex  gap-3" flexWrap={'wrap'}>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    {Array.from({ length: periodCount }, (_, i) => {
                                        const index = i + 1;
                                        const startKey = `period${index}StartDate`;
                                        const endKey = `period${index}EndDate`;

                                        return (
                                            <Box key={index} display="flex" width={'340px'} gap={1} alignItems="center">
                                                <DatePicker
                                                    label={`Period ${index} Start`}
                                                    value={periods[startKey]}
                                                    maxDate={periods[endKey]}
                                                    onChange={(value) => handleDateChange(index, "StartDate", value)}
                                                    format="DD/MM/YYYY"
                                                />

                                                <DatePicker
                                                    label={`Period ${index} End`}
                                                    value={periods[endKey]}
                                                    minDate={periods[startKey]}
                                                    onChange={(value) => handleDateChange(index, "EndDate", value)}
                                                    format="DD/MM/YYYY"
                                                />

                                                {index > 2 && (<IconButton
                                                    className='m-0 p-0'
                                                    color="error"
                                                    onClick={() => removePeriod(index)}
                                                    disabled={periodCount === 1}
                                                >
                                                    <DeleteOutline />
                                                </IconButton>
                                                )}
                                            </Box>
                                        );
                                    })}

                                </LocalizationProvider>
                            </Box>
                            <Box className='d-flex flex-column gap-2'>
                                <Button variant="contained" className='btn-main' sx={{ whiteSpace: 'nowrap' }} onClick={addNewPeriod}>
                                    Add Period
                                </Button>
                                {periodCount > 1 && (<Button variant="contained" className='btn-main' sx={{ whiteSpace: 'nowrap' }} onClick={getcategoryreport}>
                                    Compare
                                </Button>
                                )}
                            </Box>
                        </Box>
                    )
                }
                <Box className='d-flex justify-content-end'>
                    <Button variant="contained" className='button-primary' onClick={() => { handledownloadExcel() }} >
                        DOWNLOAD AS XLSX
                    </Button>
                </Box>
            </Box> */}

            <Box className='mt-3'>

                <Box className='table'>
                    <TableContainer component={Paper} sx={{ maxWidth: 'calc(100vw - 220px)' }}>
                        <Table sx={{ minWidth: 700 }} aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Site Name</StyledTableCell>
                                    {!updateUiTable ? monthList.map((month: any, index: number) => (
                                        <StyledTableCell key={index} align='center'>{month}</StyledTableCell>
                                    ))
                                        :
                                        (
                                            <>
                                                {meta && Object.values(meta).map((item: any, index: number) => (
                                                    <StyledTableCell align="center" key={index}>
                                                        {item}
                                                    </StyledTableCell>
                                                ))}
                                                <StyledTableCell align='center'>Average</StyledTableCell>
                                                <StyledTableCell align='center'>Change</StyledTableCell>
                                            </>

                                        )
                                    }
                                    {!updateUiTable && (<StyledTableCell align='center'>Average</StyledTableCell>)}
                                </TableRow>
                            </TableHead>
                            <TableBody>

                                {(categoryReport?.length > 0) ? (categoryReport?.map((item: any, index: number) => (
                                    !updateUiTable ? <StyledTableRow key={index}>
                                        <StyledTableCell >{item?.venueName}</StyledTableCell>
                                        {item?.monthlyScores?.map((item2: any, index: number) => {

                                            return (
                                                <StyledTableCell align="center" key={index}>
                                                    {item2?.score ?? "N/A"}
                                                </StyledTableCell>
                                            );
                                        })}

                                        <StyledTableCell align='center' sx={{ borderLeft: '1px solid black !important' }}>{item?.scoreAverage}</StyledTableCell>
                                    </StyledTableRow>
                                        :
                                        (
                                            <StyledTableRow key={index}>
                                                <StyledTableCell >{item?.venueName}</StyledTableCell>
                                                {item?.scores?.map((item2: any, index: number) => {

                                                    return (
                                                        <StyledTableCell align="center" key={index}>
                                                            {item2 ?? "N/A"}
                                                        </StyledTableCell>
                                                    );
                                                })}
                                                <StyledTableCell align='center' sx={{ borderLeft: '1px solid black !important' }}>{item?.averagePercentage}</StyledTableCell>
                                                <StyledTableCell align='center' sx={{ borderLeft: '1px solid black !important' }}>{item?.trend == "up" ? <TrendingUpOutlined sx={{ color: 'green' }} /> : item?.trend == "down" ? <TrendingDownOutlined sx={{ color: 'red' }} /> : ""} {item?.difference}</StyledTableCell>
                                            </StyledTableRow>
                                        )

                                ))) : <StyledTableRow><StyledTableCell className='text-center' colSpan={monthList.length + 2} sx={{ width: '100%' }}><Typography className='text-center' variant='h5'>No Data Found</Typography></StyledTableCell></StyledTableRow>}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>

            <Drawer
                anchor="right"
                open={openFilterSidebar}
                onClose={() => setOpenFilterSidebar(false)}
            >
                <Box sx={{ width: 420, p: 3 }}>
                    <Box className="d-flex justify-content-between align-items-center mb-3">
                        <Typography variant="h6" fontWeight={600}>
                            Filters
                        </Typography>
                        <IconButton
                            onClick={() => setOpenFilterSidebar(false)}
                        >
                            <CloseOutlined />
                        </IconButton>
                    </Box>
                    <Box className="d-flex flex-column gap-3">
                        {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") &&
                            storage.getItem("userRole") === "clientadmin" && (
                                <FormControlLabel
                                    control={
                                        <Switch
                                            checked={isGroupScore}
                                            onChange={(e) => {
                                                setSelectedArea(null);
                                                setisGroupScore(e.target.checked);
                                            }}
                                        />
                                    }
                                    label="Whole Group"
                                />
                            )}

                        {window.location.hostname.includes("aldi") && (
                            <Autocomplete
                                options={Regions || []}
                                getOptionLabel={(option) => option.regionName || ""}
                                value={Regions.find((item: any) => item.regionId === selectedRegion) || null}
                                onChange={(event, newValue) => {
                                    setselectedRegion(newValue?.regionId || "");
                                }}
                                renderInput={(params) => <TextField {...params} label="Region" />}
                                isOptionEqualToValue={(option, value) => option.regionId === value.regionId}
                            />
                        )}

                        {storage.getItem("userRole") === "clientadmin" &&
                            storage.getItem("ClientGroupName") !== "ALDI" && (
                                <Autocomplete
                                    options={Areamanagerlist || []}
                                    disabled={isGroupScore}
                                    getOptionLabel={(option) => option?.areaName || ""}
                                    value={Areamanagerlist?.find((item) => item.areaId === area) || null}
                                    onChange={(event, newValue) => {
                                        setSelectedArea(newValue?.areaId || "");
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Area" />}
                                    isOptionEqualToValue={(option, value) => option.areaId === value.areaId}
                                />
                            )}

                        <Autocomplete
                            multiple
                            options={venuelist || []}
                            getOptionLabel={(option) => option.venueName || ""}
                            value={venuelist?.filter((item) => venues?.includes(item.venueId)) || []}
                            onChange={(event, newValue) => {
                                setvenues(newValue.map((v) => v.venueId));
                            }}
                            renderInput={(params) => <TextField {...params} label="Sites" />}
                            isOptionEqualToValue={(option, value) => option.venueId === value.venueId}
                        />
                        {/* {(storage.getItem("ClientGroupName") === "MM" || storage.getItem("ClientGroupName") ===  "EXTENDED" || storage.getItem("ClientGroupName") === "JBHIFI") && ( */}
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isCustomDays}
                                        onChange={(e) => {

                                            setSelectedArea(null);
                                            setisCustomDays(e.target.checked);
                                            !e.target.checked && setPeriods({
                                                period1StartDate: null,
                                                period1EndDate: null,
                                                period2StartDate: null,
                                                period2EndDate: null,
                                            })
                                        }}
                                    />
                                }
                                label="Compare By Custom Dates"
                            />
                        {/* )} */}

                        {!isCustomDays ? (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Box className="d-flex flex-column gap-3">
                                    <DatePicker
                                        value={startMonth}
                                        label="Start Month"
                                        views={["month", "year"]}
                                        format="MMM-YY"
                                        maxDate={endMonth}
                                        onChange={(e) => setStartMonth(e)}
                                    />
                                    <DatePicker
                                        value={endMonth}
                                        label="End Month"
                                        views={["month", "year"]}
                                        format="MMM-YY"
                                        minDate={startMonth}
                                        onChange={(e: any) => {
                                            const isoString = e?.startOf("month").toISOString();
                                            dispatch(setSelectedMonth(isoString));
                                        }}
                                    />
                                </Box>
                            </LocalizationProvider>
                        ) : (
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <Box className="d-flex flex-column gap-4">
                                    {Array.from({ length: periodCount }, (_, i) => {
                                        const index = i + 1;
                                        const startKey = `period${index}StartDate`;
                                        const endKey = `period${index}EndDate`;

                                        return (
                                            <Box key={index} className="d-flex flex-column  gap-2">
                                                {index > 2 && (
                                                    <IconButton
                                                        className='m-0 p-0 ms-auto'
                                                        color="error"
                                                        onClick={() => removePeriod(index)}
                                                        disabled={periodCount === 1}
                                                    >
                                                        <DeleteOutline />
                                                    </IconButton>
                                                )}
                                                <DatePicker
                                                    label={`Period ${index} Start`}
                                                    value={periods[startKey]}
                                                    maxDate={periods[endKey]}
                                                    onChange={(value) => handleDateChange(index, "StartDate", value)}
                                                    format="DD/MM/YYYY"
                                                />

                                                <DatePicker
                                                    label={`Period ${index} End`}
                                                    value={periods[endKey]}
                                                    minDate={periods[startKey]}
                                                    onChange={(value) => handleDateChange(index, "EndDate", value)}
                                                    format="DD/MM/YYYY"
                                                />

                                            </Box>
                                        );
                                    })}

                                    <Button variant="contained" className="btn-main" onClick={addNewPeriod}>
                                        Add Period
                                    </Button>

                                    {/* {periodCount > 1 && (
                                        <Button variant="contained" className="btn-main" onClick={getcategoryreport}>
                                            Compare
                                        </Button>
                                    )} */}
                                </Box>
                            </LocalizationProvider>
                        )}

                        <Button
                            variant="contained"
                            className="button-primary"
                            sx={{ textTransform: 'none' }}
                            onClick={() => { getcategoryreport() }}
                        >
                            Apply
                        </Button>
                    </Box>
                </Box>
            </Drawer>
        </Box>
    )
}

export default SiteComparisionReport;
